import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmarkDelete: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bookmark-delete, remove, banner, flag, tag, x"><path d="M19.25 21V2.75H4.75V21L12 17L19.25 21Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.2981 7.70642L9.7019 12.3026" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M14.2981 12.3026L9.7019 7.70642" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconBookmarkDelete;
